/**
 * Default route to handle the loading of list view
 */
export default function defaultModuleRouterHandler() {}
